import {Task} from "@/interfaces/TaskInterfaces";

export function sortTask(a: Task, b: Task): number {
  const comparison = a.displayOrder - b.displayOrder;
  if (comparison === 0) {
    return a.title.localeCompare(b.title);
  }
  return comparison;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/utils/taskUtil.ts